import React from 'react';
// const locale = new Intl.Locale(navigator.language);
// timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
const LocaleSettingContext = React.createContext({
  timeZone: 'Iran, Tehran',
  timeZoneFullName: 'Iran, Tehran (Asia/Tehran)',
});
const { Provider: LocaleSettingProvider, Consumer: LocaleSettingConsumer } =
  LocaleSettingContext;

export { LocaleSettingContext, LocaleSettingProvider, LocaleSettingConsumer };

// import React, { createContext, useContext, useState } from "react";

// // Create a Context object
// const LocaleSettingContext = createContext();

// // Create a Provider component
// const LocaleSettingProvider = ({ children }) => {
//   const [localeSetting, setLocaleSetting] = useState(/* initial value */);

//   // Any functions that update localeSetting should be defined here

//   return (
//     <LocaleSettingContext.Provider value={{ localeSetting, setLocaleSetting }}>
//       {children}
//     </LocaleSettingContext.Provider>
//   );
// };

// // Create a custom hook to use the Context
// const useLocaleSetting = () => {
//   const context = useContext(LocaleSettingContext);
//   if (!context) {
//     throw new Error(
//       "useLocaleSetting must be used within a LocaleSettingProvider"
//     );
//   }
//   return context;
// };
// export default {
//   LocaleSettingContext,
//   LocaleSettingProvider,
//   useLocaleSetting,
// };
